/**
 * backspace event function
 * @param keyCode
 * @param value
 * @constructor
 */
export function AutoHyphenDelete(keyCode, value) {
    // if(keyCode == 189 || keyCode == 109) {}
    if(keyCode === 8 && value.charAt(value.length - 1) === '-') {
        return value.slice(0, -2);
    }
    return value;
}

export function AutoHyphenForBirthDay(value) {
    if(isNaN(Number(value.replace(/-/g,""))) || value.length > 10) {
        value = value.slice(0, -1);
    } else if(value.length === 4 || value.length === 7) {
        value += '-';
    }
    return value;
}

export function AutoHyphenForPhoneNumber(value) {
    if(isNaN(Number(value.replace(/-/g,""))) || value.length > 13) {
        value = value.slice(0, -1);
    } else if(value.length === 3 || value.length === 8) {
        value += '-';
    }
    return value
}

export function onKeyDownBlock(e) {
    if(e.keyCode === 189 || e.keyCode === 109) {
        e.preventDefault();
    }
}